module.exports = __webpack_public_path__ + "img/group-3@2x.3e916bab.png";